export const ADVISOR_CONSENT_KEY = 'odaro-advisor-consent';
export const ADVISOR_CONSENT_EVENT = 'odaro-advisor-consent-change';
export const ADVISOR_CONSENT_LIFETIME = 180 * 24 * 60 * 60 * 1000;
export type AdvisorConsent = { version: 1; allowed: boolean; savedAt: number; expiresAt: number };
export function makeAdvisorConsent(allowed: boolean, now = Date.now()): AdvisorConsent {
  return { version: 1, allowed, savedAt: now, expiresAt: now + ADVISOR_CONSENT_LIFETIME };
}
export function parseAdvisorConsent(raw: string | null, now = Date.now()): AdvisorConsent | null {
  try {
    const value = JSON.parse(raw ?? 'null');
    if (!value || value.version !== 1 || typeof value.allowed !== 'boolean' ||
      !Number.isFinite(value.savedAt) || !Number.isFinite(value.expiresAt) ||
      value.savedAt > now || value.expiresAt <= now || value.expiresAt - value.savedAt !== ADVISOR_CONSENT_LIFETIME) return null;
    return value;
  } catch { return null; }
}
